module.exports = global.config = {
//    remoteURL: "https://sgm.iridiumnorge.no"
    remoteURL: process.env.REACT_APP_BACKEND_URL
};
